import { Spinner, Message } from '../../index'
import {
  InputCheckBox,
  InputEmail,
  InputPassword,
  InputText,
} from '../../../utils/dynamicForm'

// Password inputs live in their own component so they can be conditionally
// RENDERED (create only) without conditionally CALLING the hooks that the
// InputPassword helpers use internally (which would violate the rules of hooks
// when toggling between Add and Edit).
const PasswordFields = ({ register, errors, watch }) => (
  <>
    {InputPassword({
      register,
      errors,
      label: 'Password',
      name: 'password',
      minLength: true,
      isRequired: true,
      placeholder: 'Password',
    })}

    {InputPassword({
      register,
      errors,
      watch,
      name: 'confirmPassword',
      label: 'Confirm Password',
      validate: true,
      minLength: true,
      isRequired: true,
      placeholder: 'Confirm Password',
    })}
  </>
)

const FormUsers = ({
  edit,
  formCleanHandler,
  isLoading,
  register,
  isError,
  errors,
  watch,
  isLoadingUpdate,
  isLoadingPost,
  handleSubmit,
  submitHandler,
  error,
}) => {
  return (
    <div
      className='modal fade'
      id='userModal'
      data-bs-backdrop='static'
      data-bs-keyboard='false'
      tabIndex='-1'
      aria-labelledby='userModalLabel'
      aria-hidden='true'
    >
      <div className='modal-dialog'>
        <div className='modal-content modal-background'>
          <div className='modal-header'>
            <h3 className='modal-title ' id='userModalLabel'>
              {edit ? 'Edit User' : 'Post User'}
            </h3>
            <button
              type='button'
              className='btn-close'
              data-bs-dismiss='modal'
              aria-label='Close'
              onClick={formCleanHandler}
            ></button>
          </div>
          <div className='modal-body'>
            {isLoading ? (
              <Spinner />
            ) : isError ? (
              <Message variant='danger'>{error?.error || error?.message || 'An error occurred.'}</Message>
            ) : (
              <form onSubmit={handleSubmit(submitHandler)}>
                {InputText({
                  register,
                  errors,
                  label: 'Name',
                  name: 'name',
                  placeholder: 'Name',
                })}
                {InputEmail({
                  register,
                  errors,
                  label: 'Email',
                  name: 'email',
                  placeholder: 'Email',
                })}

                {/* Optional: bind this user to their UniFi Access identity so a
                    door unlock matches them directly (no email lookup needed). */}
                {InputText({
                  register,
                  errors,
                  label: 'UniFi Access User ID',
                  name: 'unifiUserId',
                  placeholder: 'UniFi Access user id (optional)',
                  isRequired: false,
                })}

                {/* Passwords are only set when creating a user. Editing never
                    touches the password — use the per-user reset link instead. */}
                {!edit && <PasswordFields register={register} errors={errors} watch={watch} />}

                {InputCheckBox({
                  register,
                  errors,
                  watch,
                  name: 'confirmed',
                  label: 'Confirmed',
                  isRequired: false,
                  placeholder: 'Confirmed',
                })}

                {InputCheckBox({
                  register,
                  errors,
                  watch,
                  name: 'blocked',
                  label: 'Blocked',
                  isRequired: false,
                  placeholder: 'Blocked',
                })}
                <div className='modal-footer'>
                  <button
                    type='button'
                    className='btn btn-secondary '
                    data-bs-dismiss='modal'
                    onClick={formCleanHandler}
                  >
                    Close
                  </button>
                  <button
                    type='submit'
                    className='btn btn-primary '
                    disabled={isLoadingPost || isLoadingUpdate}
                  >
                    {isLoadingPost || isLoadingUpdate ? (
                      <span className='spinner-border spinner-border-sm' />
                    ) : (
                      'Submit'
                    )}
                  </button>
                </div>
              </form>
            )}
          </div>
        </div>
      </div>
    </div>
  )
}

export default FormUsers
